Core.TransportDocumentsRouter = Core.SubRouter.extend({
    routes: {
        'admin': 'adminTransportDocuments',
        'new': 'createTransportDocument',
        ':ids': 'viewTransportDocument'
    },

    adminTransportDocuments: function() {
        var collection = new Core.TransportDocuments();
        var view = new TransportDocumentsAdminView({ collection: collection });
        app.setMainView(view);  
    },

    createTransportDocument: function() {
        var jobId = Core.param('jobId');
        var wasteItemIds = Core.param('itemIds');

        $.ajax({
            type: 'GET',
            url: Core.contextRoot + '/transportdocument/template',
            data: {
                jobId: jobId,
                wasteItemIds: wasteItemIds
            },
            contentType: 'application/json',
            success: function(response) {
                var json = JSON.parse(response);
                var model = new Core.TransportDocument(json);
                var view = new TransportDocumentView({ model: model });
                app.setMainView(view);
            },
        })
    },

    viewTransportDocument: function(id) {
        var model = new Core.TransportDocument({ id: id });
        var view = new TransportDocumentView({ model: model });
        app.setMainView(view);
        return false;
    },
})